





























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import KmyLogTagText from '@/components/parts/KmyLogTagText.vue';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import SimpleCharacterList from '@/components/parts/SimpleCharacterList.vue';
import MapLogLine from '@/components/parts/MapLogLine.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import Enumerable from 'linq';
import NotificationService from '@/services/notificationservice';

@Component({
  components: {
    KmyLogTagText,
    CharacterIcon,
    SimpleCharacterList,
    MapLogLine,
  },
})
export default class BattleLogView extends Vue {
  @Prop({
    default: 0,
  })
  private logId!: number;
  @Prop() private countries!: api.Country[];
  private log: api.BattleLog = new api.BattleLog();

  private get characters(): api.Character[] {
    return [this.log.attackerCache, this.log.defenderCache];
  }

  private get attackerCountry(): api.Country {
    return this.getCountry(this.log.attackerCache.countryId);
  }

  private get defenderCountry(): api.Country {
    return this.getCountry(this.log.defenderCache.countryId);
  }

  @Watch('logId')
  private onLogIdChanged() {
    this.$emit('loading');
    api.Api.getBattleLog(this.logId)
      .then((log) => {
        this.log = log;
      })
      .catch(() => {
        NotificationService.battleLogLoadFailed.notifyWithParameter(this.logId.toString());
      })
      .finally(() => {
        this.$emit('loaded');
      });
  }

  private getCountry(id: number): api.Country {
    const country = Enumerable.from(this.countries).firstOrDefault((c) => c.id === id);
    if (country !== undefined) {
      return country;
    } else {
      return api.Country.default;
    }
  }

  private isStrongerSoldierType(a: number, b: number): boolean {
    const ai = def.SOLDIER_TYPES.find((s) => s.id === a);
    const bi = def.SOLDIER_TYPES.find((s) => s.id === b);
    if (ai && bi) {
      if (ai.attribute === 4) {
        return bi.attribute === 5;
      }
      if (ai.attribute === 5) {
        return bi.attribute === 6;
      }
      if (ai.attribute === 6) {
        return bi.attribute === 4;
      }
      if (ai.attribute === 2) {
        return bi.name.indexOf('守兵') >= 0;
      }
    }
    return false;
  }

  private isStrongerSoldierRank(a: number, b: number): boolean {
    const ai = def.SOLDIER_TYPES.find((s) => s.id === a);
    const bi = def.SOLDIER_TYPES.find((s) => s.id === b);
    if (ai && bi && ai.rank && bi.rank) {
      return ai.rank > bi.rank;
    }
    return false;
  }
}
